import { fabric } from "fabric";
import { ObjectTypesEnum } from "../../../enums";

export interface CreateIconParams {
  left: number;
  top: number;
  rowSeatSize: number;
  editable?: boolean;
  svgString: string;
  fill?: string;
  name?: string;
  visible?: boolean;
}

export class IconFactory {
  static create({
    left,
    top,
    rowSeatSize,
    editable = true,
    svgString,
    fill = "#ffffff",
    name = "New icon SVG",
    visible = false,
  }: CreateIconParams): Promise<fabric.Object> {
    return new Promise((resolve, reject) => {
      fabric.loadSVGFromString(svgString, (objects, options) => {
        if (!objects || !objects.length) {
          reject(new Error("Could not load SVG from string"));
          return;
        }

        const svg = fabric.util.groupSVGElements(objects, options);

        svg.set({
          fill,
          left,
          top,
          originX: "center",
          originY: "center",
          objectCaching: !editable,
          type: ObjectTypesEnum.Svg,
          name,
          hasControls: editable,
          hasBorders: editable,
          strokeUniform: true,
          selectable: editable,
          lockMovementX: !editable,
          lockMovementY: !editable,
          visible,
        });

        (svg as any).loadType = ObjectTypesEnum.Svg;
        (svg as any).svg = svgString;

        svg.scaleToWidth(rowSeatSize - 3);
        svg.scaleToHeight(rowSeatSize - 3);

        resolve(svg);
      });
    });
  }
}